<template>
  <div style="width: 100%;height: 100%">
    <div class="title"><span>健康数据</span></div>
    <div class="content">
      <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="bar" ref="wrap"></div>
<!--      <div style="height: 100%;width: 100%">-->
<!--        <div style="height: 100%;width: 100%" id="householdBar" ref="careWrap"></div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'healthData',
  data () {
    return {
      chart: null,
      disabledData: [],
      careData: []
    }
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    getStartData (obj) {
      let that = this
      this.careData = []
      this.disabledData = [{name: '失能', value: 0}, {name: '正常', value: 0}]

      let careLevelCountArr = obj.carelevelcount
      let isDisableCountArr = obj.isdisablecount

      this.commonType.getCareLevelArr().forEach(item => {
        let value = 0
        let careLevelCount = careLevelCountArr.find(r => r.carelevel === item.id)
        if (careLevelCount) {
          value = parseInt(careLevelCount.count)
        }
        that.careData.push({name: item.name, value: value})
      })
      // if (careLevelCountArr.find(r => r.carelevel === '0')) {
      //   this.careData.push(({name: '未知', value: careLevelCountArr.find(r => r.carelevel === '0').count}))
      // }
      this.disabledData.forEach(item => {
        if (item.name === '失能') {
          let isDisableCount = isDisableCountArr.find(r => parseInt(r.isdisable) === 0)
          if (isDisableCount) {
            item.value = parseInt(isDisableCount.count)
          }
        } else {
          let isDisableCount = isDisableCountArr.find(r => parseInt(r.isdisable) !== 0)
          if (isDisableCount) {
            item.value += parseInt(isDisableCount.count)
          }
        }
      })

      this.getChart()
    },

    getChart () {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.wrap)
      }

      let option = {
        tooltip: {
          trigger: 'item'
        },
        grid: {top: '5%', left: '5%', right: '5%', bottom: '5%', containLabel: true},
        series: [
          {
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '35%'],
            labelLine: {
              show: false
            },
            data: this.disabledData,
            label: {
              show: true,
              position: 'inner'
              // formatter: '{name|{b}}\n\n{percent|{d}%}',
              // rich: {
              //   name: {color: '#bac3c4'},
              //   percent: {color: 'auto'}
              // }
            }
          },
          {
            type: 'pie',
            radius: ['55%', '70%'],
            data: this.careData,
            label: {
              show: true,
              formatter: '{name|{b}}\n\n{percent|{d}%}',
              rich: {
                name: {color: '#bac3c4'},
                percent: {color: 'auto'}
              }
            }
          }
        ]
      }
      this.chart.setOption(option)
    },

    chartResize () {
      this.chart.resize()
    }
  }
}
</script>

<style scoped>
.title {
  padding-left: 45px;
  height: 32px;
  width: calc(100% - 45px);
  background: url("../../../assets/dataScreen/title1.png") no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 15px;
  line-height: 32px;
}
.content {
  height: calc(100% - 52px);
  width: calc(100% - 20px);
  padding: 10px;
  background-image: linear-gradient(
    #0b182c,
    #0b182c),
  linear-gradient(
    #03171f,
    #03171f);
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreenComponents/healthData.vue